import { Contratacion } from './Contratacion';
import { Usuario } from './usuario';

export class DocumentoContratacion {
    constructor(
        public id: number,
        public descripcion: string,
        public fechaSubida: string,
        public url: string,
        //Relaciones
        public UsuarioId: number,
        public ContratacionId: number,
    ){}
    
    Usuario: Usuario;

    Contratacion: Contratacion;

    fechaSubidaDate: Date
    fechaSubidaFormato: string
}